import { getToken, setToken, removeToken, getAdmin, setAdmin } from '@/utils/auth'

export default {
  namespaced: true,
  state: {
    token: getToken(),
    admin: getAdmin()
  },
  mutations: {
    SET_TOKEN(state, token) {
      state.token = token
      setToken(token)
    },
    SET_ADMIN(state, admin) {
      state.admin = admin
      setAdmin(admin)
    },
    LOGOUT(state) {
      state.token = null
      state.admin = null
      removeToken()
    }
  },
  actions: {
    login({ commit }, { token, admin }) {
      commit('SET_TOKEN', token)
      commit('SET_ADMIN', admin)
    },
    logout({ commit }) {
      commit('LOGOUT')
    }
  }
}
